// Line drawings for keys that a common symbol names: copy, share, go, random,
// and the mark of an empty scroll slot. They are in a box of 24, as the icons
// of the top bar are, and take the color of the words of their key. The words
// of the key are its label for a screen reader.

import { svg } from '../lib/svg';

const ICON_BOX = 24;

/** A path with `solid` is filled. Every other path is a line. */
type IconPart = { d: string; solid?: true };

const ICONS = {
  copy: [{ d: 'M8 8h11v11H8Z' }, { d: 'M5 15V5h10' }],
  share: [{ d: 'M12 3v12' }, { d: 'M7.5 7.5 12 3l4.5 4.5' }, { d: 'M5 12v8h14v-8' }],
  go: [{ d: 'M4 12h14' }, { d: 'M13 6.5 18.5 12 13 17.5' }],
  check: [{ d: 'M6 12.5l4 4 8-9' }],
  // A die with five pips: Random.
  random: [
    { d: 'M4 4h16v16H4Z' },
    { d: 'M7 8.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0Z', solid: true },
    { d: 'M14 8.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0Z', solid: true },
    { d: 'M10.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0Z', solid: true },
    { d: 'M7 15.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0Z', solid: true },
    { d: 'M14 15.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0Z', solid: true },
  ],
  // A rolled sheet: the mark of a scroll slot with no scroll in it.
  scroll: [
    { d: 'M7 5h11v12a2 2 0 0 1-2 2H7' },
    { d: 'M7 5a2 2 0 0 0-2 2v1h2' },
    { d: 'M7 19a2 2 0 0 1-2-2v-1h2V5' },
  ],
} satisfies Record<string, readonly IconPart[]>;

export type KeyIcon = keyof typeof ICONS;

export const createKeyIcon = (icon: KeyIcon): SVGSVGElement =>
  svg(
    'svg',
    { class: 'key-icon', viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`, 'aria-hidden': 'true' },
    ICONS[icon].map((part: IconPart) =>
      svg('path', { d: part.d, class: part.solid ? 'key-icon__solid' : 'key-icon__line' }),
    ),
  );
